import { render, staticRenderFns } from "./examlist.vue?vue&type=template&id=20eaf6c6&scoped=true"
import script from "./examlist.vue?vue&type=script&lang=js"
export * from "./examlist.vue?vue&type=script&lang=js"
import style0 from "./examlist.vue?vue&type=style&index=0&id=20eaf6c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eaf6c6",
  null
  
)

export default component.exports